import { languages } from '@getaccept/lib-shared-new/src/languages/constants/language';
import { Language } from '@getaccept/lib-shared-new/src/languages/enums/language';

export const userLanguage = (): Language => {
  try {
    const lang = window.navigator['userLanguage'] || window.navigator.language;
    return lang.substring(0, 2);
  } catch (e) {
    return Language.En;
  }
};

export const isSupportedLanguage = (language: Language) =>
  languages.some(lang => lang.key === language);
